import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "quick-answer-chat";
const keys = addTranslations(RESOURCE_NAME, {
    loading_tool: {
        en: "I’m looking through your documents and indicators to find the best answer",
        fr: "Je parcours vos documents et indicateurs pour trouver la meilleure réponse",
    },
    loading_elaborating: {
        en: "I’m analyzing the information to craft a relevant response",
        fr: "J’analyse les informations pour formuler une réponse pertinente",
    },
    input_placeholder: {
        en: "Ask any question about your Ditto data",
        fr: "Posez une question sur vos données Ditto",
    },
    no_references: {
        en: "No references found",
        fr: "Aucune référence trouvée",
    },
    indicators_title: {
        en: "Suggested indicators",
        fr: "Indicateurs suggérés",
    },
    documents_title: {
        en: "Suggested documents",
        fr: "Documents suggérés",
    },
    empty_state_title: {
        en: "Ask a question about your Ditto data",
        fr: "Posez une question sur vos données Ditto",
    },
    title_chip_title: {
        en: "Ask a question about your Ditto data",
        fr: "Posez une question sur vos données Ditto",
    },
    score_response_success: {
        en: "Feedback sent successfully",
        fr: "Feedback envoyé avec succès",
    },
    score_response_error: {
        en: "Feedback not sent",
        fr: "Feedback non envoyé",
    },
    error_message: {
        en: "Something went wrong, and the AI can't continue the conversation. To keep using it, you'll need to reload the page. \n Important: Reloading will erase your current conversation. If there's anything you want to keep, please copy the text and save it elsewhere.",
        fr: "Une erreur inattendue est survenue et l'IA ne peut pas continuer la conversation. Pour continuer à l'utiliser, vous devrez recharger la page. \n Important: Le rechargement effacera votre conversation actuelle. Si vous souhaitez conserver quelque chose, veuillez copier le texte et l'enregistrer ailleurs.",
    },
    example_message_chip_iso: {
        en: "Do you have an ISO 14001 certification?",
        fr: "Êtes-vous certifiés ISO 14001?",
    },
    example_message_chip_policy: {
        en: "Do you have an environmental policy?",
        fr: "Avez-vous une politique environnementale ?",
    },
    example_message_chip_scope2: {
        en: "What are your scope 2 emissions?",
        fr: "Quelles sont vos émissions scope 2 ?",
    },
    example_message_chip_siret: {
        en: "What is your SIRET?",
        fr: "Quel est votre SIRET?",
    },
});

export function useQuickAnswerChatTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
